<template>
    <transition name="toggleContentComponent">
        <article class="imageAndTextTemplate " v-if="ready">
            <div class="img-container">
                <img v-show="this.properties?.image" :src="getMediaPath">
            </div>
            <div class="text-container background-gradient">
                <h2>{{ properties?.title }}</h2>
                <div class="scroll-container" v-html="properties?.description"></div>
            </div>
        </article>
    </transition>
</template>
<script>

export default {
    props: ['properties', 'slug'],
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.ready = true;
    },
    methods: {
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        }
    },
    computed: {
        getMediaPath() {
            return app.api.Utils.getMediaPath(this.properties?.image?.src)
        },
    }
}
</script>


<style lang="scss" scoped>
.imageAndTextTemplate {
    height: 100%;
    inset: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .img-container {
        overflow: hidden;
    }

    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
}

.text-container {
    &>* {
        max-width: 845px;
    }
}
</style>